/* eslint-disable react/react-in-jsx-scope */
import axios from "axios"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"
import "./CardProcesso.css"
import formatNumber from "./formatNumber"

const apolicesStats = [
  {
    title: "Total de Apólices Mapeadas",
    key: "totalApolicesMapeadas",
    icon: "bx bx-file-blank",
    gradient: "linear-gradient(135deg, #6B8DE3 0%, #4318FF 100%)",
    isCurrency: false,
  },
  {
    title: "Apólices a Vencer nos próximos 6 meses",
    key: "apolicesAVencer6Meses",
    icon: "bx bx-calendar-event",
    gradient: "linear-gradient(135deg, #FF6B6B 0%, #EE5A24 100%)",
    isCurrency: false,
  },
  {
    title: "IS Envolvida",
    key: "isEnvolvida",
    icon: "bx bx-trending-up",
    gradient: "linear-gradient(135deg, #49B5C0 0%, #1A97F5 100%)",
    isCurrency: true,
  },
  {
    title: "Prêmio Envolvido",
    key: "premioEnvolvido",
    icon: "bx bx-coins",
    gradient: "linear-gradient(135deg, #FFAA2B 0%, #FB9678 100%)",
    isCurrency: true,
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
}

const cardVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
}

const numberVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
}

const CardApolices = () => {
  const [apolicesData, setApolicesData] = useState({
    totalApolicesMapeadas: 0,
    apolicesAVencer6Meses: 0,
    isEnvolvida: 0,
    premioEnvolvido: 0
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchApolicesStats = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_API_EXT_LEADS}/api/processos/policies-stats`)
        
        setApolicesData(response.data)
        setError(null)
      } catch (err) {
        console.error('Erro ao buscar estatísticas de apólices:', err)
        setError(err.response?.data?.message || err.message || 'Erro ao carregar dados')
      } finally {
        setLoading(false)
      }
    }

    fetchApolicesStats()
  }, [])

  const formatCurrency = (value) => {
    const numValue = Number(value) || 0
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue)
  }

  const renderApoliceValue = (stat) =>
    loading ? (
      <Spinner size="sm" color="light" />
    ) : error ? (
      <span className="text-white-50">Erro</span>
    ) : stat.isCurrency ? (
      formatCurrency(apolicesData[stat.key] || 0)
    ) : (
      formatNumber(apolicesData[stat.key] || 0)
    )

  return (
    <div className="dashboard-stats">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Card className="shadow-lg border-0 rounded-lg">
          <CardBody>
            <Row className="mb-4">
              <Col lg="12">
                <h3 className="text-gradient fw-bold">
                  Estatísticas de Apólices
                </h3>
              </Col>
            </Row>
            <Row>
              {apolicesStats.map((stat, index) => (
                <Col lg="3" key={index}>
                  <motion.div variants={cardVariants}>
                    <Card
                      className="stat-card border-0 h-100"
                      style={{ background: stat.gradient }}
                    >
                      <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="stat-icon me-3">
                            <span className="rounded-circle bg-white bg-opacity-10 text-white">
                              <i className={`${stat.icon} fs-4`} />
                            </span>
                          </div>
                          <h5 className="text-white mb-0 fw-semibold">
                            {stat.title}
                          </h5>
                        </div>
                        <div className="mt-4">
                          <motion.div
                            variants={numberVariants}
                            className="d-flex align-items-center"
                          >
                            <h2 className="text-white mb-0 me-2 fw-bold">
                              {renderApoliceValue(stat)}
                            </h2>
                            <span className="badge bg-white bg-opacity-10 text-white">
                              {stat.isCurrency ? 'Valor' : 'Total'}
                            </span>
                          </motion.div>
                        </div>
                        {stat.key === 'apolicesAVencer6Meses' && !loading && !error && (
                          <div className="mt-2">
                            <small className="text-white-50">
                              Próximos 6 meses
                            </small>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </motion.div>
    </div>
  )
}

export default CardApolices
